<template>
    <div class="dm-wizard-field" v-if="presentation">
        <VueDropzone
            class="dropzone dropzone-default dz-clickable dz-started mb-4 p-0"
            :accepted_file_types="['image/png', 'image/jpeg']"
            :upload_url="uploadUrl"
            @uploadSuccessful="replaceIllustrations"
            @uploadFailedDueToFileTypes="showFileTypesError"
        >
            <div class="dropzone-msg dz-message needsclick p-4">
                <h3 class="dropzone-msg-title">
                    {{ translate("Show sample artwork here") }}
                </h3>
                <span class="dropzone-msg-desc">{{
                    translate("We only receive .jpg, .png files")
                }}</span
                ><br />
                <span class="dropzone-msg-desc">{{
                    translate("Maximum file size is 50MB")
                }}</span>
            </div>
        </VueDropzone>
    </div>
</template>

<script>
import { validationMixin } from "@/mixins/validationMixin.js";
import VueDropzone from "@/components/shared/VueDropzone.vue";
import { useSubmissionWizardStore } from "@storesSw/SubmissionWizardStore";
import { mapState } from "pinia";

export default {
    components: { VueDropzone },

    mixins: [validationMixin],

    computed: {
        ...mapState(useSubmissionWizardStore, ["presentation"]),

        uploadUrl() {
            return (
                "/api/author/presentations/" +
                this.presentation.id +
                "/illustrations"
            );
        },
    },

    methods: {
        // Replaces the 'illustrations' prop without having to reload from server.
        replaceIllustrations(data) {
            this.presentation.illustrations = data.illustrations;
        },

        showFileTypesError() {
            this.showSwalErrorPopup("Please select only JPG or PNG files!");
        },
    },
};
</script>
